export const GNB_HEIGHT = 48;

const CONTENT_MIN_WIDTH = 680;
const SUMMARY_MIN_WIDTH = 400;
const CONTENT_GAP = 32;
const PADDING_HORIZONTAL = 32;

export const FORM_LAYOUT_STYLE = {
  CONTENT_MIN_WIDTH,
  SUMMARY_MIN_WIDTH,
  CONTENT_GAP,
  CONTAINER_WIDTH: CONTENT_MIN_WIDTH + SUMMARY_MIN_WIDTH + CONTENT_GAP + PADDING_HORIZONTAL * 2,
  PADDING_HORIZONTAL,
};

export const DEFAULT_LAYOUT_STYLE = {
  MIN_WIDTH: 744,
};
